import { render, staticRenderFns } from "./reportStatistics.vue?vue&type=template&id=a3b48508&scoped=true"
import script from "./reportStatistics.vue?vue&type=script&lang=js"
export * from "./reportStatistics.vue?vue&type=script&lang=js"
import style0 from "./reportStatistics.vue?vue&type=style&index=0&id=a3b48508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b48508",
  null
  
)

export default component.exports